// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__hOpJh","options":"AnswerScale_options__3mLd4","selected":"AnswerScale_selected__j_rl_"};